import { applicationState } from 'data/state';

import {
  DEFAULT_LOGIN_REDIRECT_URL,
  PARTNER_LOGIN_REDIRECT_URL,
  WATR_LOGIN_REDIRECT_URL,
  ROOT_DOMAIN,
} from 'lib/constants';

function getLocationState(propLocation, field, defaultValue = null) {
  let value;
  if (propLocation.state) {
    value = propLocation.state[field];
  }
  return value || defaultValue;
}

function isAllowedHostname(hostname: string): boolean {
  const allowedDomains = [ROOT_DOMAIN, 'force.com'];
  return allowedDomains.some(
    (domain) => hostname === domain || hostname.endsWith('.' + domain)
  );
}

function redirectToNextUrl(nextUrl) {
  let url: URL;
  try {
    url = new URL(nextUrl);
  } catch {
    alert('Invalid next argument');
    return;
  }

  if (!isAllowedHostname(url.hostname)) {
    alert('Invalid next argument');
    return;
  }
  window.location.assign(nextUrl);
}

function redirectToMainApp(subUrl='') {
  // add next behavior later..
  let url = DEFAULT_LOGIN_REDIRECT_URL;

  if (subUrl) {
    if (!subUrl.startsWith('/')) {
      subUrl = '/' + subUrl;
    }
    url += subUrl;
  }

  window.location.assign(url);
}

export { getLocationState, redirectToMainApp, redirectToNextUrl };
